import { useState, useEffect } from "react";
// material
import { Box, Card } from "@mui/material";
import Label from "../Label";
// components
import Scrollbar from "../table/Scrollbar";
import TableView from "../Table";
import { parseDateTime } from "../../utils/tableFunctions";
import {
  getHistoryEntityList,
  getHistoryEntityFilterConditions,
} from "../../services/services";

import CircularLoader from "../circularLoader";
import FormSearch from "../FormSearch";
import { MAPPED_REGISTERED_COUNTRY, pageNumber, rowsPerPage } from "../../utils/constants";
import CommonDialog from "../CustomDialog";
import HeaderHelpPage from "../HeaderHelpPage";
import EntityDetails from "../../pages/details/entity/EntityDetails";

// ----------------------------------------------------------------------

export default function Entity() {
  const [historyGroup, setHistoryGroup] = useState();
  const [loaded, setLoaded] = useState(false);
  const [tableData, setTableData] = useState();
  const [filterName, setFilterName] = useState();
  const [fParams, setFParams] = useState({});
  const [pagination, setPagination] = useState({
    page: pageNumber,
    page_size: rowsPerPage,
  });
  const [itemId, setItemId] = useState(null);

  // ------------------ filterStuffies --------------------//
  const [fLoaded, setFLoaded] = useState(false);
  const [inputValues, setInputValues] = useState({});

  const queryPage = (queryParams, params) => {
    setLoaded(false);
    getHistoryEntityList({
      setResponse: setHistoryGroup,
      filter: params || inputValues,
      setLoaded,
      page: queryParams.page,
      page_size: queryParams.page_size,
    });
    setPagination(queryParams);
  };

  const onFilterSubmit = (params) => {
    const newParams = { 
      ...params,
      business_name: params.business_name?.id,
      business_name_input: inputValues?.business_name?.trim() || null
    };
    const newPagination = {
      ...pagination,
      page: 1,
    };
    queryPage(newPagination, newParams);
  };

  useEffect(() => {
      getHistoryEntityFilterConditions(setFParams, setFLoaded);
      queryPage(pagination);
  }, []);

  const formatData = (input) => {
    let tableData = [];
    input.forEach(
      ({
        id,
        business_name,
        registered_country,
        created_at,
        is_approved,
        action,
      }) => {
        tableData.push({
          id: id,
          business_name: business_name ? business_name.toUpperCase() : "",
          registered_country:
            registered_country && MAPPED_REGISTERED_COUNTRY[registered_country.registered_country],
          created_on: parseDateTime(created_at),
          action: action,
          approved: (
            <>
              <Label variant="ghost" color={is_approved ? "success" : "error"}>
                {is_approved ? "YES" : "NO"}
              </Label>
            </>
          ),
        });
      }
    );
    return tableData;
  };

  useEffect(() => {
    if (historyGroup?.results) {
      setTableData(formatData(historyGroup.results));
    }
  }, [historyGroup]);

  const schema = [
    {
      type: "search-select",
      label: "Business Name",
      param: "business_name",
      options: fParams?.business_name?.map((entity) => ({
        id: entity,
        label: entity?.toUpperCase()
      })),
      inputValues,
      setInputValues,
    },
    {
      type: "select",
      label: "Registered Country",
      param: "registered_country",
      options: fParams?.registered_country?.map((country) => ({
        id: country.registered_country__id,
        name: MAPPED_REGISTERED_COUNTRY[country.registered_country__registered_country],
      }))
    },
    {
      type: "select",
      label: "Action",
      param: "action",
      id: false,
      options: ["Add", "Remove", "Update"]
    },
    {
      type: "select",
      label: "Approved",
      param: "is_approved",
      options: [
        { name: "Yes", id: true },
        { name: "No", id: false },
      ]
    }
  ]

  return (
    <Box>
      <FormSearch
        schema={schema}
        loading={!fLoaded}
        onSearch={onFilterSubmit}
      />
      {loaded ? (
        <Card>
          <Scrollbar>
            <TableView
              rows={tableData}
              link={`/3/app/entity-details~id~?action=true`}
              onSelectItem={(id) => setItemId(id)}
              count={historyGroup?.count}
              pagination={pagination}
              getNext={queryPage}
              data={tableData}
            />
          </Scrollbar>
        </Card>
      ) : (
        <CircularLoader />
      )}

      {itemId && (
        <CommonDialog
          title={<HeaderHelpPage title="Business Entity Details" variant="h5" mb={0} />}
          onClose={() => setItemId(null)}
        >
          <EntityDetails itemId={itemId} isViewHistory />
        </CommonDialog>
      )}
    </Box>
  );
}
